export default "__VITE_ASSET__c3b5c83b__"